import { Pipe, PipeTransform, inject } from '@angular/core';
import { PermissionService } from './permission.service';

@Pipe({ name: 'canTab', pure: false, standalone: false })
export class CanTabPipe implements PipeTransform {
  private permissionService = inject(PermissionService);


  transform(tab: number): boolean {
    return this.permissionService.canTab(tab);
  }
}
